module.exports = __webpack_public_path__ + "fonts/Lora-Medium.2e5042f1.ttf";